export enum AuthQrantTypeEnum {
  LDAP = 'LDAP',
  STANDARD = 'USERPASS'
}



// WEBPACK FOOTER //
// ./src/app/enums/authQrantType.enum.ts